<ul class="menu-main">
  <li [class.active]="active === 'Shows'">
    <a href="#" (click)="$event.preventDefault()"
      ><span class="icon ib-show"></span>Shows</a
    >
  </li>
  <li [class.active]="active === 'Attractions'">
    <a href="#" (click)="$event.preventDefault()"
      ><span class="icon ib-attraction"></span>Attractions</a
    >
  </li>
  <li [class.active]="active === 'Lodging'">
    <a href="#" (click)="$event.preventDefault()"><span class="icon ib-lodging"></span>Lodging</a>
  </li>
  <li [class.active]="active === 'Dining'">
    <a href="#" (click)="$event.preventDefault()"
      ><span class="icon ib-dining"></span>Dining</a
    >
  </li>
  <li>
    <a href="#" (click)="$event.preventDefault()"
      ><span class="icon ib-vacation-package"></span>Vacation Packages</a
    >
  </li>
  <li>
    <a href="#" (click)="$event.preventDefault()"><span class="icon ib-deals"></span>Deals</a>
  </li>
</ul>
